/* eslint-disable */
import { calculateEnthalpy, getIncidentEnergy, getWattsAsKilowattsPer15Seconds,getThermalEnergyStored } from 'src/utils/calculations';
import { degToCompass, transpose, getDishSensors, getLoopSensors, getWeatherSensors, getWeatherSensorValue, getWeatherSensorKey } from 'src/utils/miscTools';


export function prepD2aysData(daysRaw) {

  if (daysRaw.length > 0) {
  var enthalpyDaySoFar = [];
    for (let i = 0; i < daysRaw.length; i++) {
      var inlet = daysRaw[i][2];
      var outlet = daysRaw[i][3];
      var flow = daysRaw[i][4];
      enthalpyDaySoFar.push(calculateEnthalpy(inlet, outlet, flow));
    }
    var transposedData =  transpose(daysRaw);
    var times = transposedData[0];
    var incidentEnergyReadings = transposedData[1].map(x => x * 13.94);

    var totalIncident = getDaysTotal(incidentEnergyReadings);
    var totalCollected = getDaysTotal(enthalpyDaySoFar);
    var totalEfficiency = getDaysEfficiencyTotal(totalIncident, totalCollected);

    return  {
      times,
      enthalpy: enthalpyDaySoFar,
      incident: incidentEnergyReadings,
      totalIncident,
      totalCollected,
      totalEfficiency 
    }
  } else {
    return {
      times: [],
      enthalpy: [],
      incident: [],
      totalIncident: 0,
      totalCollected: 0,
      totalEfficiency: 0, 
    };
  }
}

export function getDaysTotal(collected) {
  if(typeof collected !== "undefined"){
    var total =  collected.reduce((a, b) => {
      if (b >=0){
        return a + b;
      }else{
        return a;
      }
    });
    return getWattsAsKilowattsPer15Seconds(total);
  } else {
    return 0; 
  } 
}
  
export function getDaysEfficiencyTotal(totalIncident,totalCollected ) {
  var totalEfficiency = 0;
    if(totalIncident < 0.2 ){
      totalEfficiency = 0.0;
    }else{
      totalEfficiency = Number((totalCollected / totalIncident) * 100);
    }
    return Number(totalEfficiency);
}

export function prepNewData(latestReadings){
  const parsedReadings = JSON.parse(latestReadings);
  var sumDNI = 0;
  var countDNIsensors = 0;
  var sumInput = 0;
  var sumOutput = 0
  var flowRate = 7.1; // SET THIS BY ITERATING OVER LOOP BEFORE DISHES

  flowRate = (parsedReadings.secondaryLoopData[0].loopReadings['flowLPM']);
  
  for (var x in parsedReadings.concentratorData) {
      let concentrator = parsedReadings.concentratorData[x]
      // Set values for new metrics for individual dish 
      var receiverInput = concentrator.concentratorReadings['receiverInput'];
      var receiverOutput = concentrator.concentratorReadings['receiverOutput'];
      var mastInput =  concentrator.concentratorReadings['ambientTemp'];
      concentrator.concentratorReadings['mastInput'] = mastInput;
      var mastOutput =  concentrator.concentratorReadings['cabinetTemp'];
      concentrator.concentratorReadings['mastOutput'] = mastOutput;
      var deltaT = receiverOutput-receiverInput
      concentrator.concentratorReadings['deltaT'] = deltaT;
      
      var solarZenith = concentrator.concentratorReadings['calculatedZenith'];
      var solarAzimuth = concentrator.concentratorReadings['calculatedAzimuth'];
      var dishZenith = concentrator.concentratorReadings['dishZenith'];
      var dishAzimuth = concentrator.concentratorReadings['dishAzimuth'];
      
      concentrator.concentratorReadings['zenithDeviation'] = solarZenith - dishZenith;
      concentrator.concentratorReadings['azimuthDeviation'] = solarAzimuth -dishAzimuth;
      // set calculated metrics for individual
      if(concentrator.concentratorReadings.hasOwnProperty('concentratorDNISensor')){
        var incident = getIncidentEnergy(concentrator.concentratorReadings['concentratorDNISensor']);
        concentrator.concentratorReadings['incidentEnergy'] = incident;
        sumDNI += concentrator.concentratorReadings['concentratorDNISensor'];
        countDNIsensors ++;
      }else{
        concentrator.concentratorReadings['incidentEnergy'] = 'No DNI sensor';
      }
      var collected = calculateEnthalpy(receiverInput, receiverOutput, flowRate);
      concentrator.concentratorReadings['collectedEnergy'] = collected;
      // Extract necessary metrics for global calculations. 
      sumInput += receiverInput;
      sumOutput += receiverOutput;
  }
  // SET GLOBAL METRIC VALUES
  let avgDNI = sumDNI/countDNIsensors;
  let DNIPerDish = getIncidentEnergy(avgDNI);
  let installationIncidentEnergy = DNIPerDish * parsedReadings.concentratorData.length;
  parsedReadings['installationIncidentEnergy'] = installationIncidentEnergy;
  let installationCollectedEnergy = calculateEnthalpy(sumInput, sumOutput, flowRate);
  parsedReadings['installationCollectedEnergy'] = installationCollectedEnergy
  parsedReadings['installationConversionEfficiency'] = (installationCollectedEnergy/installationIncidentEnergy)*100;
  parsedReadings['installationEnergyStored'] = 0;
  parsedReadings['installationEnergySupplied'] = 0;

  return parsedReadings;
}


function getReadingsObj(content, timestamp){
    var readings = getBlankReadingObj();
    // console.log(content);
    readings["Timestamp"] = new Date(timestamp).toLocaleString("en-US");
    let dishSensors = content.concentratorData.concentratorReadings;
    let loopSensors = content.secondaryLoopData.loopReadings;
    let weatherSensors = content.weatherStationData.weatherData;
    
    
    try{
        if(dishSensors != undefined){
          console.log("we have dish");
          for (const [key, value] of dishSensors) {
            console.log(key);
                readings[key].value = value;    
            }
        }
           // console.log(readings); 
        if  (loopSensors != undefined){
           for (let i = 0; i < loopSensors.length; i++) {
                var value = loopSensors[i].SensorValue
                var heading_text = loopSensors[i].SensorRole;
                readings[loopSensors[i].SensorRole].value = value;        
            } 
        }
        
        if(weatherSensors != undefined){
           for (let i = 0; i <= 6; i++) {
                var value = getWeatherSensorValue(i, weatherSensors)
                var heading_text = getWeatherSensorKey(i);               
                readings[heading_text].value =Number(value);        
            } 
        }
         

        readings["MastInput"] = readings["AmbientTemp"]
        readings["MastOutput"] = readings["CabinetTemp"]
        readings["DeltaT"].value = Number(readings["ReceiverOutput"].value - readings["ReceiverInput"].value).toFixed(1);
        
        readings["Incident Energy (kWh)"].value = (Number(getIncidentEnergy(readings["ConcentratorDNISensor"].value)));
        readings["Collected Energy (kWh)"].value = (Number(calculateEnthalpy(readings["ReceiverInput"].value, readings["ReceiverOutput"].value, readings["flow lpm"].value)));
        readings["Conversion Efficiency"].value =    Number(( readings["Collected Energy (kWh)"].value / ( readings["Incident Energy (kWh)"].value)) * 100);
        readings["Heat Energy Supplied"].value =  Number(getWattsAsKilowattsPer15Seconds(calculateEnthalpy(readings["out greenhouse"].value, readings["in greenhouse"].value, 14)))
        readings["Heat Energy Stored"].value = Number(getThermalEnergyStored(readings["storage tank"].value,readings["out greenhouse"].value))

    }catch(e){
      console.log(e)
    }
    return readings;
}


function getBlankReadingObj(){
  var readings = {
  "Timestamp": "UNAVAILABLE",
  "Incident Energy (kWh)":{ type: "Calculated", value:"UNAVAILABLE", unit:"kWh", category:"Calculated System Metrics"},
  "Collected Energy (kWh)":{ type: "Calculated", value:"UNAVAILABLE", unit:"kWh", category:"Calculated System Metrics"},
  "Conversion Efficiency":{ type: "Calculated", value:"UNAVAILABLE", unit:"%", category:"Calculated System Metrics"},
  "Heat Energy Supplied":{ type: "Calculated", value:"UNAVAILABLE", unit:"kWh", category:"Calculated System Metrics"},
  "Heat Energy Stored":{ type: "Calculated", value:"UNAVAILABLE", unit:"kWh", category:"Calculated System Metrics"},

  "ReceiverInput":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Concentrator Telemetry"},
  "ReceiverOutput":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Concentrator Telemetry"},
  "AmbientTemp":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Concentrator Telemetry"},
  "ConcentratorDNISensor":{ type: "Pyranometer", value:"UNAVAILABLE", unit:"W/m²", category:"Concentrator Telemetry"},
  "CabinetTemp":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Concentrator Telemetry"},
  "DishAzimuth":{ type: "PositionEncoder", value:"UNAVAILABLE", unit:"°", category:"Concentrator Telemetry"},
  "DishZenith":{ type: "PositionEncoder", value:"UNAVAILABLE", unit:"°", category:"Concentrator Telemetry"},
  "CalculatedAzimuth":{ type: "Calculated", value:"UNAVAILABLE", unit:"°", category:"Concentrator Telemetry"},
  "CalculatedZenith":{ type: "Calculated", value:"UNAVAILABLE", unit:"°", category:"Concentrator Telemetry"},
  "MastInput":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Concentrator Telemetry"},
  "MastOutput":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Concentrator Telemetry"},
  "DeltaT":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Concentrator Telemetry"},
  

  "flow lpm":{ type: "FlowMeter", value:"UNAVAILABLE", unit:"L/min", category:"Secondary Loop Telemetry"},
  "out greenhouse":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Secondary Loop Telemetry"},
  "in greenhouse":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Secondary Loop Telemetry"},
  "supply shed":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Secondary Loop Telemetry"},
  "return shed":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Secondary Loop Telemetry"},
  "storage tank":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Secondary Loop Telemetry"},
  "heat dump in":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Secondary Loop Telemetry"},
  "heat dump out":{ type: "Thermocouple", value:"UNAVAILABLE", unit:"°C", category:"Secondary Loop Telemetry"},
  "ventOutside":{ type: "N/A", value:"UNAVAILABLE", unit:"N/A", category:"Secondary Loop Telemetry"},
  "ventInside":{ type: "N/A", value:"UNAVAILABLE", unit:"N/A", category:"Secondary Loop Telemetry"},
  "heatDumpRunning":{ type: "N/A", value:"UNAVAILABLE", unit:"N/A", category:"Secondary Loop Telemetry"},


  "Air Temp":{ type: "WeatherStation", value:"UNAVAILABLE", unit:"°C", category:"Weather Readings"},
  "Solar Intensity":{ type: "WeatherStation", value:"UNAVAILABLE", unit:"W/m²", category:"Weather Readings"},
  "Wind Speed (inst)":{ type: "WeatherStation", value:"UNAVAILABLE", unit:"Km/h", category:"Weather Readings"},
  "Wind Speed (avg)":{ type: "WeatherStation", value:"UNAVAILABLE", unit:"Km/h", category:"Weather Readings"},
  "Wind Speed (max)":{ type: "WeatherStation", value:"UNAVAILABLE", unit:"Km/h", category:"Weather Readings"},
  "Wind Direction":{ type: "WeatherStation", value:"UNAVAILABLE", unit:"°N", category:"Weather Readings"},
  "Humidity":{ type: "WeatherStation", value:"UNAVAILABLE", unit:"%", category:"Weather Readings"},
  "Derived DNI":{ type: "Calculated", value:"UNAVAILABLE", unit:"W/m²", category:"Weather Readings"}
    
}   
return readings;
}